import { render, staticRenderFns } from "./HeroAnnouncement.vue?vue&type=template&id=3522819c&scoped=true"
import script from "./HeroAnnouncement.vue?vue&type=script&lang=ts"
export * from "./HeroAnnouncement.vue?vue&type=script&lang=ts"
import style0 from "./HeroAnnouncement.vue?vue&type=style&index=0&id=3522819c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3522819c",
  null
  
)

export default component.exports